import * as React from "react"
import i18n from "i18n"
import { SwitchSeeker } from "ui-seeker/core"


export default function SwitchMinStay({ leftText, rightText, siteName, grid, ...props }) {

    return <div className="switch-price-night" style={{ display: 'flex', alignItems: 'center', height: '38px', marginLeft: 8 }}>
		{ leftText || '' }
		<SwitchSeeker {...props} />
		<span style={{ fontSize: 13, whiteSpace: 'nowrap' }}>{ rightText || i18n.t('common:filters.minStay') }</span>
	</div>
}